import { render, staticRenderFns } from "./ReportAdmin.vue?vue&type=template&id=7f826b9c&"
import script from "./ReportAdmin.vue?vue&type=script&lang=ts&"
export * from "./ReportAdmin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports